<template>
  <div>

    <v-container>
      <v-form ref="form">
        <v-row>
          <v-col cols="11">
            <v-card
                class="mx-auto"
            >
              <v-card-text>
                <v-card-title class="headline">
                  {{ reportName }}
                </v-card-title>
                <v-row justify="center" align="center">
                  <v-col cols="3">
                    <z-source-selector @changevalue="changeReportType" :search="true" label="报表类型选择"
                                       v-model="queryRequest.reportPath"
                                       :rules="[v => !!v || '必输']"
                                       :source="'ReportPathSelector'"/>
                  </v-col>
                  <v-col cols="4" v-if="isNeed">
                    <z-source-selector
                        :search="true" label="选择设备名称" @changevalue="changeAssetsNames"
                        v-model="queryRequest.assetsNames"
                        :rules="[v => v.length>0 || '必选']"
                        multiple :isDisabled="isDisabled"
                        :source="'AssetsNameSelector'"/>
                  </v-col>
                  <v-col cols="3">
                    <z-select-month @change="changeMonth"
                                    :rules="[v => !!v || '必输']"
                                    :allowed-dates="allowedDates"
                                    v-model="queryRequest.dateMonth"></z-select-month>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn style="float:right "
                       color="primary"
                       @click=downLoadReport
                >
                  报表下载
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <z-loading v-model="isShowLoading"></z-loading>

    <z-notify ref="notify"></z-notify>
  </div>
</template>

<script>

import {
  reportExport
} from "@/api/reportDownload"
import downloadReportExcel from "@/utils/reportDownLoad"

export default {
  name: "Report",
  data() {
    return {
      isDisabled: false,
      isNeed: false,
      isShowLoading: false,
      reportName: '报表下载',
      queryRequest: {
        reportPath: '',
        assetsNames: [],
        dateMonth: ''
      },
    }
  },
  mounted() {
    var todayDate = new Date();
    var year = todayDate.getFullYear();
    var month = todayDate.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    this.queryRequest.dateMonth = year + '-' + month;
  },
  methods: {
    allowedDates(val) {
      return Date.parse(val) < Date.now()
    },
    changeReportType() {
      console.log(this.queryRequest.reportPath)
      this.queryRequest.assetsNames = [];
      if (this.queryRequest.reportPath == '/assets-month-use-report' || this.queryRequest.reportPath == '/assets-mouth-use-count-time-report') {
        this.isNeed = false;
      } else {
        this.isNeed = true;
      }
    },
    changeAssetsNames() {
      console.log(this.queryRequest.reportPath)
      if (this.queryRequest.assetsNames.length > 3) {
        // console.log(this.queryRequest.reportPath, '-++++++++++++++')
        // this.$refs.notify.show("设备名称不能超过三个", {timeout: 1000, color: 'red'});
        // this.queryRequest.assetsNames.pop();
        // return;
      } else {

      }
    },
    changeMonth(month) {
      this.queryRequest.dateMonth = month;
    },
    downLoadReport() {
      console.log(this.queryRequest.assetsNames,'Names')
      if (!this.$refs.form.validate()) {
        console.log("??????????????")
        console.log(this.queryRequest.assetsNames,'Names')
        return;
      }
      // 按月科室报表下载按钮
      this.isShowLoading = true;
      reportExport(this.queryRequest).then(res => {
        console.log(res, "res");
        downloadReportExcel(res);
        this.isShowLoading = false;
      }).catch(err => {
        this.isShowLoading = false;
      });
    },
  },
}
</script>

<style scoped>

</style>

